query getMarketMinutely($market_id: String, $endTime: Float) {
    getMarketMinutely(market_id: $market_id, endTime: $endTime) {
        close
        timestamp
        volume
    }
}
